import { render, staticRenderFns } from "./border_config.vue?vue&type=template&id=05b5cc3b&"
import script from "./border_config.vue?vue&type=script&lang=js&"
export * from "./border_config.vue?vue&type=script&lang=js&"
import style0 from "./border_config.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports